<template>
  <b-container fluid>
    <b-row>
      <b-col class="d-flex">
        <backlink class="mt-20" />
        <div class="flex-grow-1">
          <h1>
            Environnement de stockage
            <div v-if="!isBusy" class="subtitle">#{{ values.name }}</div>
          </h1>
        </div>
        <div v-if="values.id" class="text-right">
          <b-button variant="outline-primary ml-10" size="lg" @click="openFormModal(values.id)">
            Modifier la fiche
            <i class="far fa-pencil fa-lg ml-10"></i>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content divided">
            <b-row>
              <b-col>
                <dl>
                  <dt>{{ labels.warehouse }} :</dt>
                  <dd>{{ values.warehouse || '-' }}</dd>
                  <dt>{{ labels.storage_zone }} :</dt>
                  <dd>{{ values.storage_zone || '-' }}</dd>
                  <dt>{{ labels.parent_storage_environment }} :</dt>
                  <dd>{{ values.parent_storage_environment || '-' }}</dd>
                  <dt>{{ labels.storage_type }} :</dt>
                  <dd>{{ values.storage_type || '-' }}</dd>
                </dl>
              </b-col>
              <b-col class="d-flex flex-column barcode-col">
                <h3>Code barre</h3>
                <b-row class="flex-grow-1 flex-column barcode-wrapper justify-content-center">
                  <div class="text-center">
                    <div>{{ values.internal_code }}</div>
                  </div>
                  <barcode
                    class="text-center"
                    :value="values.internal_code"
                    :displayValue="false"
                    height="50"
                  >Impossible de générer le code à barres</barcode>
                </b-row>
                <b-row>
                  <b-col class="text-center bottom-link">
                    <a href @click.prevent="printBarcode()">
                      Imprimer
                      <i class="fa fa-chevron-right"></i>
                    </a>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm
      v-if="config.useNewModal || config.useEditModal"
      :config="config"
      :id_to_edit="id_to_edit"
    />
  </b-container>
</template>

<script>
import config from "./config";
import AdminModalForm from "@/components/Global/AdminModalForm";
import barcodeLabel from "@/mixins/barcodeLabel";

export default {
  name: "StorageEnvironmentDetail",
  mixins: [barcodeLabel],
  components: {
    AdminModalForm
  },
  data() {
    return {
      config: config,
      labels: {},
      storageLocations: [],
      isBusy: false,
      id_to_edit: null
    };
  },
  computed: {
    rawValues: function() {
      return (
        this.$store.getters[config.storeNamespace + "/getItem"](
          this.$route.params.id
        ) || {}
      );
    },
    values: function() {
      return this.$root.formatData(
        this.rawValues,
        this.config.fields.filter(field => field.inDetail == true)
      );
    }
  },
  mounted() {
    // Chargement des champs à afficher dans le détail depuis la config
    // Et récupération des libellés
    config.fields
      .filter(field => field.inDetail == true)
      .forEach(field => {
        this.labels[field.name] = field.label;
      });

    this.isBusy = true;
    this.$store
      .dispatch(config.storeNamespace + "/getItem", {
        id: this.$route.params.id,
        wait: true
      })
      .then(() => {
        // Test si le contenu demandé est bien trouvé
        let self = this;
        if (Object.entries(this.rawValues).length <= 0) {
          this.$toastr.error(
            "La fiche demandée n'a pas été trouvée. Assure-vous que l'URL saisie soit correcte."
          );
          setTimeout(function() {
            self.$router.go(-1);
          }, 5000);
          return;
        }
        this.isBusy = false;
      });
  },
  methods: {
    openFormModal(id) {
      this.id_to_edit = id;
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
    printBarcode() {
      this.printBarcodeLabel();
    }
  }
};
</script>

<style lang="scss">
.barcode-wrapper > :nth-child(1) {
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/StorageEnvironment/StorageEnvironmentDetail.vue